import { Link } from "react-router-dom";

export default function WhatIsSection() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-10 lg:px-16 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          <div className="lg:w-1/2">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
              <i className="ri-information-line"></i>
              <span>Co to jest?</span>
            </div>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 tracking-tight leading-tight">
              Czym jest <span className="text-primary-600">Kakobuy Spreadsheet</span>?
            </h2>
            <p className="text-foreground-600 mt-5 text-sm leading-relaxed max-w-lg">
              Kakobuy Spreadsheet to uporządkowana baza produktów pomagająca użytkownikom szybciej znaleźć popularne produkty, trendy oraz najlepsze okazje na chińskich platformach zakupowych. To kompleksowe narzędzie, które łączy w sobie funkcje wyszukiwarki produktów, porównywarki cen i przewodnika zakupowego.
            </p>
            <p className="text-foreground-600 mt-3 text-sm leading-relaxed max-w-lg">
              Nasz arkusz jest regularnie aktualizowany przez zespół doświadczonych researcherów, którzy codziennie przeszukują chińskie marketplace w poszukiwaniu najlepszych okazji. Każdy produkt jest weryfikowany pod kątem jakości, popularności i stosunku ceny do wartości.
            </p>
            <Link
              to="/artykul/kakobuy-spreadsheet-poradnik"
              className="inline-flex items-center gap-2 mt-6 text-primary-600 text-sm font-medium hover:text-primary-700 transition-colors"
            >
              <i className="ri-book-open-line"></i>
              Dowiedz się więcej w naszym poradniku
            </Link>
          </div>

          <div className="lg:w-1/2">
            <div className="relative">
              <div className="rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Clean%20minimalist%20desk%20setup%20with%20open%20notebook%20and%20coffee%20cup%20beside%20a%20small%20terracotta%20planter%20with%20green%20plant%2C%20soft%20natural%20window%20light%20from%20left%2C%20editorial%20workspace%20photography%2C%20warm%20beige%20and%20dusty%20olive%20green%20color%20scheme%2C%20calm%20focused%20atmosphere%20with%20wooden%20desk%20texture&width=800&height=600&seq=what-is-workspace-v2&orientation=landscape"
                  alt="Kakobuy Spreadsheet w użyciu"
                  className="w-full h-72 md:h-80 object-cover object-top"
                />
              </div>
              <div className="absolute -bottom-4 -right-4 bg-background-50 rounded-xl p-4 border border-background-200/60 shadow-sm">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center">
                    <i className="ri-database-2-line text-accent-600"></i>
                  </div>
                  <div>
                    <p className="text-foreground-900 font-heading font-bold text-base">1000+</p>
                    <p className="text-foreground-500 text-xs">Zweryfikowanych linków</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}